var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progress)?_c('b-progress',{staticClass:"progress-bar-success my-1",attrs:{"max":"100"}},[_c('b-progress-bar',{attrs:{"value":_vm.progress,"label":(_vm.progress + "%"),"variant":"success"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }